// Neue Version - Stand 21.11.2023

function toggleBodyScroll(state) {
    if (state === "disable") {
        document.body.classList.add('no-scroll');
    } else {
        document.body.classList.remove('no-scroll');
    }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector("#angebot-btn-1").addEventListener('click', function (e) {
      e.stopPropagation();
      document.querySelector("#angebot-popup").style.display = 'block';
      document.querySelector("#angebot-popup .popup").style.display = 'block';
      document.querySelector("header.main-header").style.zIndex = '0';
      document.querySelector("#shopify-section-product-recommendations").style.zIndex = '-1';
      toggleBodyScroll("disable");
  }, false);
  
  document.querySelector("#angebot-btn-2").addEventListener('click', function (e) {
      e.stopPropagation();
      document.querySelector("#angebot-popup").style.display = 'block';
      document.querySelector("#angebot-popup .popup").style.display = 'block';
      document.querySelector("header.main-header").style.zIndex = '0';
      document.querySelector("#shopify-section-product-recommendations").style.zIndex = '-1';
      toggleBodyScroll("disable");
  }, false);
  
  document.querySelector("#angebot-popup-close").addEventListener('click', function () {
      document.querySelector("#angebot-popup").style.display = 'none';
      document.querySelector("#angebot-popup .popup").style.display = 'none';
      document.querySelector("header.main-header").style.zIndex = '6';
      document.querySelector("#shopify-section-product-recommendations").style.zIndex = '0';
      toggleBodyScroll("enable");
  }, false);
  
  document.querySelector("#angebot-popup").addEventListener('click', function (e) {
      e.stopPropagation();
  }, false);
  
  document.querySelector("body").addEventListener('click', function () {
      document.querySelector("#angebot-popup").style.display = 'none';
      document.querySelector("#angebot-popup .popup").style.display = 'none';
      toggleBodyScroll("enable");
  }, false);
});
